import { useQuery } from '@tanstack/react-query';
import { getBusinessDailySummary, getDailySummary } from '../lib/dailyApi';

/**
 * Load the combined daily summary (calendar + grouped tasks) for a user/date.
 * Cached for 5 minutes per NFR-DAILY-002.
 */
export function useDailySummary(userId: string | undefined, date: string | undefined) {
  return useQuery({
    queryKey: ['daily-summary', userId, date],
    queryFn: () => getDailySummary(userId!, date),
    enabled: Boolean(userId),
    staleTime: 5 * 60 * 1000,
  });
}

/**
 * Load the business-wide ("All Users") daily summary for a date: every active
 * team member with their tasks grouped on the due-date timeline (CLE-58).
 * `enabled` lets the page skip the request when an individual user is selected.
 */
export function useBusinessDailySummary(date: string | undefined, enabled: boolean) {
  return useQuery({
    queryKey: ['business-daily-summary', date],
    queryFn: () => getBusinessDailySummary(date),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
